import { combineEpics, Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import {
  switchMap,
  map,
  startWith,
  catchError,
  filter,
  tap
} from 'rxjs/operators';
import { isOfType } from 'typesafe-actions';
import { Position, Toaster, Intent } from '@blueprintjs/core';

import {
  ViewTreeTypes,
  ViewTreeAction,
  loading,
  loaded,
  loadingFailed,
} from '../actions/viewTreeActions';
import { IState } from '../reducers';
import {
  getViewTree
} from '../../services/viewTreeApi';
import { ApiParams } from '../../models';

const loadViewTreeEpic: Epic<ViewTreeAction, ViewTreeAction, IState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(isOfType(ViewTreeTypes.LOAD_VIEW_TREE)),
    switchMap(action => {
      return from(getViewTree(action.payload)).pipe(
        map((response: any) => loaded(response.result)),
        startWith(loading()),
        catchError(() => of(loadingFailed()))
      );
    })
  );

export default combineEpics(
  loadViewTreeEpic
);
